import api from "./api";

const clientService = {
    findClientByEmailOrDocument: (jwttoken, findUserBy, userKey) =>
        api.get(`/clients/find/findClientByEmailOrDocument?findUserBy=${findUserBy}&userKey=${userKey}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
};

export default clientService;